import { Directive, ElementRef, AfterViewInit, OnDestroy, inject, effect, input } from '@angular/core';
import { SidebarStateService } from './sidebar-state.service';
import { BootstrapTooltipInstance } from '../shared/types/bootstrap-global';

@Directive({
  selector: '[ofSidebarTooltip]',
  standalone: true
})
export class SidebarTooltipDirective implements AfterViewInit, OnDestroy {
  readonly text = input('', { alias: 'ofSidebarTooltip' });
  readonly tooltipPlacement = input('right');

  private tooltip: BootstrapTooltipInstance | null = null;
  private readonly sidebarState = inject(SidebarStateService);
  private readonly el = inject(ElementRef<HTMLElement>);

  constructor() {
    effect(() => {
      if (this.sidebarState.expanded()) {
        this.tooltip?.disable();
      } else {
        this.tooltip?.enable();
      }
    });
  }

  ngAfterViewInit(): void {
    const bootstrap = window.bootstrap;
    const text = this.text();
    if (!bootstrap?.Tooltip || !text) return;

    this.tooltip = new bootstrap.Tooltip(this.el.nativeElement, {
      title: text,
      placement: this.tooltipPlacement(),
      trigger: 'hover',
      container: 'body',
      delay: { show: 300, hide: 0 }
    });

    if (this.sidebarState.expanded()) {
      this.tooltip.disable();
    }
  }

  ngOnDestroy(): void {
    this.tooltip?.dispose();
  }
}
